import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState } from "react";
import HomePageSection from "./assets/pages/HomePageSection.jsx";

// import Header from "./assets/component/Header.jsx"; 
import AuthModal from "./assets/component/AuthModal.jsx"; 
import PaymentModal from "./assets/component/PaymentModal.jsx"; 
import Footer from "./assets/component/Footer.jsx";

import './assets/style/global.css';
import './assets/style/pages/homepage.css';

import './assets/style/pages/UpcomingSkins.css';
import './assets/style/pages/AboutUs.css';
import './assets/style/pages/SkinDrops.css';
import './assets/style/pages/spotlight.css';
import './assets/style/pages/whychoose.css';
import './assets/style/pages/UnlockDifferent.css';
import './assets/style/pages/Faq.css';

import './assets/style/component/footer.css';
import './assets/style/component/header.css';
import './assets/style/component/AuthModal.css';
import './assets/style/component/PaymentModal.css'; 
import './assets/style/pages/categoriespage/alsoneed.css';

import FeaturePageSection from "./assets/pages/FeaturePageSection.jsx";
import ContactUs from "./assets/pages/ContactUs.jsx";
// import Cart from "./assets/component/Cart.jsx";

import Pistols from "./assets/pages/CategoriesPageSection/pistols.jsx";
import Rifles from "./assets/pages/CategoriesPageSection/rifle.jsx";
import MidTier from "./assets/pages/CategoriesPageSection/MidTier.jsx";
import Knives from "./assets/pages/CategoriesPageSection/Knives.jsx";
import Gloves from "./assets/pages/CategoriesPageSection/Gloves.jsx";
import Cases from "./assets/pages/CategoriesPageSection/Cases.jsx";
import Collection from "./assets/pages/CategoriesPageSection/collections.jsx";  
import Stickers from "./assets/pages/CategoriesPageSection/Stickers.jsx";
import Agents from "./assets/pages/CategoriesPageSection/Agents.jsx";

import Items from "./assets/pages/CategoriesPageSection/items";
import CategoriesPage from "./assets/pages/CategoriesPageSection/CategoriesPage.jsx";


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return !!localStorage.getItem("authToken"); 
  });

  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isPaymentModalOpen, setPaymentModalOpen] = useState(false); 
  const [selectedSkin, setSelectedSkin] = useState(null); 

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userEmail");
    setIsLoggedIn(false);
  };

  const handleBuyNow = (skin) => {
    setSelectedSkin(skin);
    if (isLoggedIn) {
      setPaymentModalOpen(true);
    } else {
      setLoginModalOpen(true);
    }
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Homepage */}
        <Route path="/" element={<HomePageSection 
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          isLoginModalOpen={isLoginModalOpen}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />} />
        <Route path="/features" element={<FeaturePageSection 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />}/>
        <Route path="/contact" element={<ContactUs 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />}/>
        {/* <Route path="/cart" element={<Cart />}/> */}
        <Route
            path="/categories"
            element={
              <CategoriesPage
                isLoggedIn={isLoggedIn}
                setLoginModalOpen={setLoginModalOpen}
                handleLogout={handleLogout}
              />
            }
          />
        <Route path="/categories/pistols" element={<Pistols 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />} />
        <Route path="/categories/rifle" element={<Rifles 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />} />
        <Route path="/categories/mid-tier" element={<MidTier 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />} />
        <Route path="/categories/knives" element={<Knives 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />}/>
        <Route path="/categories/gloves" element={<Gloves 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />}/>
        <Route path="/categories/cases" element={<Cases 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />}/>
        <Route path="/categories/collections" element={<Collection 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />} />
        <Route path="/categories/stickers" element={<Stickers 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />} />
        <Route path="/categories/agents" element={<Agents 
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
        />} />
        <Route path="/items/:name" element={<Items 
         isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          handleLogout={handleLogout}
           />} />
        
      </Routes>
      {isLoginModalOpen && (
        <AuthModal
          setIsModalOpen={setLoginModalOpen}
          setIsLoggedIn={setIsLoggedIn}
          setPaymentModalOpen={setPaymentModalOpen}
          selectedSkin={selectedSkin}
        />
      )}
      {isPaymentModalOpen && (
        <PaymentModal
          setIsModalOpen={setPaymentModalOpen}
          selectedSkin={selectedSkin}
          setSelectedSkin={setSelectedSkin}
        />
      )}
      <Footer />
    </BrowserRouter>
  );
}

export default App;